import CompanyItem from "./CompanyItem";

export default CompanyItem;
